export default class WooFilterApplyFloatingButtonComponent {
  constructor(obj) {
    this.obj = obj;
    this.button = this.obj.querySelector(".ds-woo-filter__apply-button");
    this.objQuantity = this.obj.querySelector(".ds-woo-filter__apply-filter-container__products-quantity");
    this.objLabel = this.obj.querySelector(".ds-woo-filter__apply-filter-container__products-label");

    this.listen();
  }

  clearState() {
    this.obj.classList.remove("ds-woo-filter__apply-filter-container--show");
    this.obj.classList.remove("ds-woo-filter__apply-filter-container--inactive");
    this.obj.classList.remove("ds-woo-filter__apply-filter-container--loading");
  }

  show() {
    this.clearState();
    this.obj.classList.add("ds-woo-filter__apply-filter-container--show");
  }

  hide() {
    this.clearState();
  }

  enable() {
    this.clearState();
  }

  disable() {
    this.clearState();
    this.obj.classList.add("ds-woo-filter__apply-filter-container--inactive");
  }

  pending() {
    this.clearState();
    this.obj.classList.add("ds-woo-filter__apply-filter-container--loading");
    this.obj.classList.add("ds-woo-filter__apply-filter-container--show");
  }

  setProductsCount(count) {
    if (this.objQuantity) {
      this.objQuantity.textContent = String(count);
    }

    if (this.objLabel) {
      this.objLabel.textContent = count === 1 ? "product" : "products";
    }

    this.enable();
    this.show();
  }

  listen() {
    if (!this.button) {
      return;
    }

    this.button.addEventListener("click", () => {
      this.onClick();
      this.hide();
    });
  }

  onClick() {}
}
